import React, { useState, useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import Skeleton from "react-loading-skeleton";
// import "./ErrorDrgReport.css";

import ReportTable from "../ReportTable";
// import ErrorDrgReportFilter from "./ErrorDrgReportFilter";
import { useReport } from "../hooks/useReport";
import { batchUpdateAppliedFilters } from "../redux/ReportsSlice";

import totalOutstanding from "../../../../common/assets/images/notification-box.png";
import highPriority from "../../../../common/assets/images/highPriority.png";
import calendar from "../../../../common/assets/images/calendar.png";
import hourglass from "../../../../common/assets/images/hourglass.png";
// import { exportReportData } from "../redux/ReportsSlice";
import { getReportConfig } from "../optionsConfig";
import { useSelector } from "react-redux";
import CoblMissingMvdsReportFilter from "./CoblMissingMvdsReportFilter";

const REPORT_PATH = "/missing-mvds-report";
const reportAPIConfig = getReportConfig(REPORT_PATH);


const CoblMissingMvdsReport = () => {
  const dispatch = useDispatch();
const appliedFilters = useSelector(
  (s) => s.reports.appliedFilters[REPORT_PATH] || {});

  const {
    episodes,
    reportData,
    totalPages,
    pageNumber,
    setPageNumber,
    reportLoading,
    reportError,
    exportLoading,
    // handleExport,
    handleReset,
    resetSignal,
    setSortPayload,
    pageSize,
    setPageSize
  } = useReport(REPORT_PATH);

  const [searchText, setSearchText] = useState("");
const [sortPayload, setSortPayloadState] = useState({});
  // ── Column-header filter apply (same pattern as DRGReport) ──
  const handleColumnFilterApply = useCallback(
    (filters) => {
      dispatch(
        batchUpdateAppliedFilters({
          reportPath: REPORT_PATH,
          filters,
        }),
      );
      setPageNumber(1);
    },
    [dispatch, setPageNumber],
  );

  // ── Single-field search (no field toggle needed for Error DRG) ──
  const handleSearchChange = useCallback(
    (value) => {
      setSearchText(value || "");
      dispatch(
        batchUpdateAppliedFilters({
          reportPath: REPORT_PATH,
          filters: { search: value || "" },
        }),
      );
      setPageNumber(1);
    },
    [dispatch, setPageNumber],
  );
  
  useEffect(() => {
  const updatePageSize = () => {
    const screenHeight = window.innerHeight;

    // Header + widgets + pagination space
    const availableHeight = screenHeight - 335;

    // Approximate row height
    const rowHeight = 36;

    const dynamicRows = Math.floor(availableHeight / rowHeight);
    const newPageSize = dynamicRows > 10 ? dynamicRows : 10;

    setPageSize((prevPageSize) => {
      if (prevPageSize !== newPageSize) {
        setPageNumber(1);
        return newPageSize;
      }

      return prevPageSize;
    });
  };

  updatePageSize();

  window.addEventListener("resize", updatePageSize);

  return () => {
    window.removeEventListener("resize", updatePageSize);
  };
}, [setPageNumber, setPageSize]);
const buildExportPayload = useCallback((filters, search, sort) => {
  const payload = {};

  if (search) payload.search_term = [search];
  if (sort?.sort_by) payload.sort_by = sort.sort_by;
  if (sort?.sort_order) payload.sort_order = sort.sort_order;

  if (filters.missing_notes_flag) payload.missing_notes_flag = filters.missing_notes_flag;
  if (filters.discharge_date_from) payload.discharge_date_from = filters.discharge_date_from;
  if (filters.discharge_date_to) payload.discharge_date_to = filters.discharge_date_to;

  ["episode_id", "episode_type", "speciality", "status", "drg_code"].forEach(
    (k) => {
      if (Array.isArray(filters[k]) && filters[k].length > 0) {
        payload[k] = filters[k];
      }
    }
  );

  return payload;
}, []);

  

  return (
    <div className="outstanding-filters-section mt-3 px-2">
      <h4 className="pb-2" style={{ flexShrink: 0 }}>
        Missing MVDS Report
      </h4>

      <ReportTable
        key="error-drg"
        episodes={episodes}
        isReportLoading={reportLoading}
        isReportError={reportError}
        reportPageNumber={pageNumber}
        setReportPageNumber={setPageNumber}
        // handleReportExport={handleExport}
        reportExcelLoading={exportLoading}
        handleSearchChange={handleSearchChange}
        totalPages={totalPages}
        searchText={searchText}
        setSearchText={setSearchText}
        onSortChange={setSortPayload}
        onReset={handleReset}
        resetSignal={resetSignal}
        onColumnFilterApply={handleColumnFilterApply}
        reportData={reportData}
      />

      <CoblMissingMvdsReportFilter onApply={() => setPageNumber(1)} />
    </div>
  );
};

export default CoblMissingMvdsReport;
